import * as braze from "@braze/web-sdk";

export function initBraze() {
  const sdkKey = process.env.BRAZE_SDK_KEY;
  const sdkEndpoint = 'https://sdk.iad-05.braze.com';
  const isDevelopment = process.env.NODE_ENV === 'development';
  
  return braze.initialize(sdkKey, {
    baseUrl: sdkEndpoint,
    enableLogging: isDevelopment,
    allowUserSuppliedJavascript: true,
    minimumIntervalBetweenTriggerActionsInSeconds: 3,
    devicePropertyAllowlist: ['browser', 'browserVersion', 'os', 'resolution'],
    allowCrawlerActivity: true
  });
}

export function setBrazeOptions() {
  braze.changeUser(window.gon?.user?.id || 'not_logged_in');
  braze.subscribeToInAppMessage((inAppMessage) => {
    try {
      braze.showInAppMessage(inAppMessage);
    } catch (error) {
      console.error('Failed to show message:', error);
    }
  });

  braze.openSession();
}

export function logViewArticle() {
  braze.logCustomEvent('snow_view_article_js');
}
